import { NgModule }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IvrComponent } from './ivr.component'
import { DIDComponent } from './did.component';
import { HorarioComponent } from './horario.component';
import { SecuenciaComponent } from './secuencia.component';
import { FiltroPorContextoPipe } from './contexto.pipe';

import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';

@NgModule({
    imports: [BrowserModule, FormsModule, ReactiveFormsModule, FileUploadModule],
    declarations: [IvrComponent, DIDComponent, HorarioComponent, SecuenciaComponent, FiltroPorContextoPipe],
    exports: [IvrComponent, DIDComponent, HorarioComponent, SecuenciaComponent, FiltroPorContextoPipe]
})
export class IvrModule{}





// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/ivr/ivr.module.ts